/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from 'react'
import { FC } from 'react'
import { KTSVG } from '../../../_metronic/helpers'
import MediaCard from './components/MediaCard'
import { getExplores } from '../../../api/endpoints/explore'
import InfiniteScroll from 'react-infinite-scroll-component'
import UserProfileHeader from './components/UserProfileHeader'
import UserProfileFooter from './components/UserProfileFooter'
import Lightbox from 'yet-another-react-lightbox'
import Video from 'yet-another-react-lightbox/plugins/video'
import Captions from 'yet-another-react-lightbox/plugins/captions'
import 'yet-another-react-lightbox/styles.css'
import 'yet-another-react-lightbox/styles.css'
import 'yet-another-react-lightbox/plugins/captions.css'
import { MediaFilters } from './components/MediaFilters'
import {
  addMediaToState,
  aggregateFilter,
  getAllMediaAction,
  mediaFilterSelector,
  mediaPaginationSelector,
  mediasSelector,
  mediaStatusSelector,
} from '../../reducers/exploreReducer'
import { useDispatch, useSelector } from 'react-redux'
import client from '../../../api'
import { useEffect } from 'react'
import { useState } from 'react'
import heic2any from 'heic2any'
import { data } from '../configuration/data'
import MUITable from '../../modules/common/MUITable'
import { FaEye } from 'react-icons/fa'
import TableLoading from '../../../_metronic/layout/components/Common/TableSkeletonLoading'
import { current } from '@reduxjs/toolkit'


type MediaItem = {
  id: string;
  thumbnail: string | string[];
};

/** Supports legacy string URLs and new array of URLs (thumbnail / url) */
const getMediaUrls = (value: string | string[] | undefined | null): string[] => {
  if (Array.isArray(value)) return value.filter((v): v is string => typeof v === 'string' && !!v)
  if (typeof value === 'string' && value) return [value]
  return []
}

const getMediaUrl = (value: string | string[] | undefined | null): string =>
  getMediaUrls(value)[0] || ''

const uploadedByName = (row: any) => {
  if (row?.uploadedBy === 'P') {
    if (!row.provider) return 'N/A'
    const providerName =
      (row.provider.first_name || '') + ' ' + (row.provider.last_name || '').trim()
    return providerName || 'N/A'
  }
  if (row?.uploadedBy === 'C') {
    if (!row.client) return 'N/A'
    const clientName = (row.client.first_name || '') + ' ' + (row.client.last_name || '').trim()
    return clientName || 'N/A'
  }
  return 'Unknown'
}

type Props = {}

const Explore: FC<Props> = () => {
  const dispatch: any = useDispatch()

  const [open, setOpen] = React.useState(false)

  const [item, setItem] = React.useState<any>(0)

  const media: any = useSelector(mediasSelector)
  const mediaStatus = useSelector(mediaStatusSelector)
  const pagination = useSelector(mediaPaginationSelector)
  const filtersData = useSelector(mediaFilterSelector)

  const [convertedImages, setConvertedImages] = useState<{ [key: string]: string }>({});
  const [loadingPercentage, setLoadingPercentage] = useState<{ [id: string]: number }>({});

  const [selectedMedia, setSelectedMedia] = useState<any>(null)
  const [slideIndex, setSlideIndex] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [rowsPerPage, setRowsPerPage] = useState<number>(10)

  const openMediaDetail = (row: any) => {
    setSelectedMedia(row)
    setSlideIndex(0)
    setOpen(true)
  }

  const closeMediaDetail = () => {
    setOpen(false)
    setSelectedMedia(null)
    setSlideIndex(0)
  }

  const detailSlides = React.useMemo(() => {
    if (!selectedMedia) return []

    const urls = getMediaUrls(selectedMedia?.url)
    const thumbnails = getMediaUrls(selectedMedia?.thumbnail)
    // Prefer the multi-image array when available (url or thumbnail)
    const sources =
      urls.length > 1
        ? urls
        : thumbnails.length > 1
        ? thumbnails
        : urls.length > 0
        ? urls
        : thumbnails
    const isImage = selectedMedia?.type?.includes('image')

    return sources.map((sourceUrl: string, i: number) => {
      const conversionKey = `${selectedMedia?.id}-${i}`
      const isHeic = sourceUrl?.toLowerCase().endsWith('.heic')
      const src =
        isHeic && convertedImages[conversionKey]
          ? convertedImages[conversionKey]
          : isHeic && convertedImages[selectedMedia?.id]
          ? convertedImages[selectedMedia?.id]
          : sourceUrl
      const poster = thumbnails[i] || thumbnails[0] || src

      if (isImage) {
        return {
          src,
          title: (
            <UserProfileHeader
              data={selectedMedia}
              uploadedByName={uploadedByName(selectedMedia)}
            />
          ),
          description: <UserProfileFooter item={{...selectedMedia, url: sourceUrl}} />,
        }
      }

      return {
        type: 'video' as const,
        width: 1050,
        height: 550,
        poster,
        title: (
          <UserProfileHeader
            data={selectedMedia}
            uploadedByName={uploadedByName(selectedMedia)}
          />
        ),
        description: <UserProfileFooter item={{...selectedMedia, url: sourceUrl}} />,
        sources: [{src: sourceUrl, type: `${selectedMedia?.type}/mp4`}],
      }
    })
  }, [selectedMedia, convertedImages])

  useEffect(() => {
    dispatch(
      getAllMediaAction({
        page: currentPage,
        perPage: rowsPerPage,
        sort: 'id|desc',
      })
    )
    return () => {
      // setMediaList([])
    }
  }, [currentPage, rowsPerPage])

  const getMedia = async () => {
    const params = { ...filtersData, perPage: 10 }
    const res: any = await dispatch(getAllMediaAction(params))
    if (res.data) {
      dispatch(addMediaToState(res.data))
    }
  }

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      getMedia()
    }, 1000)
    return () => clearTimeout(delayDebounce)
  }, [filtersData])

  const handleChange = (e: any) => {
    if (e.target.value.length < 2) {
      dispatch(aggregateFilter({ key: 'query', value: '' }))
    } else {
      if (e.target.value.length > 2) {
        dispatch(aggregateFilter({ key: 'query', value: e.target.value.toUpperCase() }))
      }
    }
  }

  useEffect(() => {
    const convertHeicToJpeg = async (thumbnail: string, id: string) => {
      try {
        if (convertedImages[id]) return;
        if (thumbnail.toLowerCase().endsWith('.heic')) {
          const xhr = new XMLHttpRequest();
          xhr.open('GET', thumbnail, true);
          xhr.responseType = 'blob';

          xhr.onprogress = (event) => {
            if (event.lengthComputable) {
              // Download progress: 0-80%
              const percentComplete = (event.loaded / event.total) * 80;
              setLoadingPercentage((prev) => {
                const updated = {
                  ...prev,
                  [id]: Math.round(percentComplete),
                };
                return updated;
              });
            }
          };

          xhr.onload = async () => {
            if (xhr.status === 200) {
              const blob = xhr.response;
              // Download complete, set to 80%
              setLoadingPercentage((prev) => ({ ...prev, [id]: 80 }));

              try {
                // Simulate conversion progress from 80% to 99%
                let conversionProgress = 80;
                const interval = setInterval(() => {
                  conversionProgress += 4;
                  setLoadingPercentage((prev) => ({ ...prev, [id]: Math.min(conversionProgress, 99) }));
                  if (conversionProgress >= 99) clearInterval(interval);
                }, 100);

                const converted = await heic2any({ blob, toType: 'image/jpeg', quality: 0.8 });
                clearInterval(interval);
                setLoadingPercentage((prev) => ({ ...prev, [id]: 100 }));

                const jpegUrl = URL.createObjectURL(converted as Blob);
                setConvertedImages((prev) => ({ ...prev, [id]: jpegUrl }));
              } catch (err) {
                console.error("HEIC conversion failed:", err);
              }

              // Clean up percentage state after a short delay to allow image to render
              setTimeout(() => {
                setLoadingPercentage((prev) => {
                  const { [id]: _, ...rest } = prev;
                  return rest;
                });
              }, 500);
            }
          };

          xhr.onerror = () => {
            console.error('Error fetching HEIC image');
            setLoadingPercentage((prev) => ({
              ...prev,
              [id]: 0,
            }));
          };

          xhr.send();
        } else {
          setConvertedImages((prev) => ({ ...prev, [id]: thumbnail }));
        }
      } catch (err) {
        console.error('HEIC conversion failed:', err);
      }
    };

    media.forEach((item: any) => {
      const thumbnail = getMediaUrl(item?.thumbnail)
      const id = item?.id || thumbnail
      if (thumbnail?.toLowerCase().endsWith('.heic') && !convertedImages[id]) {
        convertHeicToJpeg(thumbnail, id)
      }
    })
  }, [media, convertedImages])

  const TaggedName = (row: any) => {
    if (row?.tagged) {
      const updated = row?.tagged?.isTypeContent === 1 ? row?.tagged?.businessName : (row?.tagged?.first_name || '') + ' ' + (row?.provider?.last_name || '');
      return updated;
    }
    return 'N/A';
  }

  const columns = [
    {
      id: 'index',
      label: '#',
      align: 'center',
      render: (_: any, i: number) => i + 1 + (currentPage - 1) * rowsPerPage,
    },
    {
      id: 'thumbnail',
      label: 'Thumbnail',
      align: 'center',
      render: (row: any, i: number) => {
        const thumbnail = getMediaUrl(row?.thumbnail);
        const isHeic = thumbnail?.toLowerCase().endsWith('.heic');
        const id = row?.id || thumbnail;
        const src = isHeic ? convertedImages[id] : thumbnail;

        const percentage = loadingPercentage[id];
        const isConverted = !!convertedImages[id];

        if (isHeic && !isConverted) {
          return (
            <div
              style={{
                width: 70,
                height: 70,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 6,
                backgroundColor: '#f0f0f0',
              }}
              className='text-primary'
            >
              {typeof percentage === 'number' && percentage < 100 ? (
                <span>{percentage}%</span>
              ) : null}
            </div>
          );
        }

        return (
          <img
            src={src}
            alt='media'
            style={{ width: 70, height: 70, objectFit: 'cover', borderRadius: 6, cursor: 'pointer' }}
            onClick={() => openMediaDetail(row)}
          />
        );
      },
    },

    {
      id: 'type',
      label: 'Type',
      align: 'center',
      render: (row: any) => row?.isPost === 1 ? 'Post' : 'Media',
    },
    {
      id: 'caption',
      label: 'Caption',
      align: 'center',
      render: (row: any) =>
        <div style={{ maxWidth: '300px', whiteSpace: 'normal' }}>
          {row?.caption || 'N/A'}
        </div>
    },
    {
      id: 'adminPrivacy',
      label: 'Admin Privacy',
      align: 'center',
      render: (row: any) => row?.isAdminPrivate === 1 ? 'True' : 'False',
    },
    {
      id: 'clientPrivacy',
      label: 'Client Privacy',
      align: 'center',
      render: (row: any) => row?.isClientPrivate === 1 ? 'True' : 'False',
    },
    {
      id: 'providerPrivacy',
      label: 'Provider Privacy',
      align: 'center',
      render: (row: any) => row?.isProviderPrivate === 1 ? 'True' : 'False',
    },
    {
      id: 'tags',
      label: 'Tags',
      align: 'center',
      render: (row: any) => {
        const names = row?.tags?.length > 0 ? row?.tags?.map((tag: any) => tag?.service?.name || '_') : ['N/A'];
        return <div style={{ maxWidth: '200px', whiteSpace: 'normal' }}>
          {names.join(', ')}
        </div>;
      },
    },
    {
      id: 'tagged',
      label: 'Tagged',
      align: 'center',
      render: (row: any) => TaggedName(row),
    },
    {
      id: 'uploadedBy',
      label: 'Uploaded By',
      align: 'center',
      render: (row: any) => uploadedByName(row),
    },

    {
      id: 'createdAt',
      label: 'Created At',
      align: 'center',
      render: (row: any) => {
        const date = new Date(row?.createdAt);
        return date.toLocaleDateString('en-US', {
          month: '2-digit',
          day: '2-digit',
          year: 'numeric'
        });
      },
    },
  ]

  const structuredRows = media?.map((row: any, index: number) => {
    const newRow: any = {}
    columns.forEach((col) => {
      newRow[col.id] = col.render ? col.render(row, index) : row[col.id]
    })
    newRow.id = row.id
    return newRow
  })

  const tableData = {
    table: {
      columns,
      rows: structuredRows,
    },
    pagination: {
      total: pagination?.total || 0,
      lastPage: pagination?.lastPage || 1,
    },
  }

  return (
    <>
      <div className='row mb-5 mt-n5 pt-n5'>
        <div className='col-6'>
          <h2 className='py-3 mb-2'>Feed</h2>
        </div>
        {/* <div className='col-6 align-self-center text-end'>
          <MediaFilters filtersData={filtersData} />
        </div> */}
      </div>
      <div className='card mb-5 mb-xl-10 pt-4'>
        {/* search section */}
        <div className='d-flex align-items-center justify-content-end my-3 px-4'>
          <KTSVG
            path='/media/icons/duotune/general/gen021.svg'
            className='svg-icon-1 position-absolute me-5'
          />
          <input
            onChange={handleChange}
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder='Search media'
          />
        </div>
        {/* {media?.length === 0 ? (
          <div
            style={{ minHeight: '50vh' }}
            className={`card mb-5 mb-xl-10 py-8 d-flex justify-content-center`}
          >
            <div className='d-flex justify-content-center my-5'>
              <div className='spinner-grow text-dark' role='status'>
                <span className='sr-only'>Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <InfiniteScroll
            dataLength={media?.length} //This is important field to render the next data
            next={() => getMedia()}
            hasMore={pagination?.nextPageUrl}
            loader={
              <div className='d-flex justify-content-center my-5'>
                <div className='spinner-grow text-dark' role='status'>
                  <span className='sr-only'>Loading...</span>
                </div>
              </div>
            }
            endMessage={
              <p style={{ textAlign: 'center' }}>
                <b>Yay! You have seen it all</b>
              </p>
            }
          >
            <div className='row w-100 m-auto align-items-center mt-4'>
              {media?.map((data: any, idx: number) => {
                const thumbnail = getMediaUrl(data?.thumbnail);
                const id = data?.id;
                const isHeic = thumbnail?.toLowerCase().endsWith('.heic');
                const src = isHeic ? convertedImages[id] : thumbnail;

                if (isHeic && !convertedImages[id]) {
                  return (
                    <div
                      key={idx}
                      className="col-md-4 d-flex justify-content-center align-items-center"
                      style={{ height: '200px' }}
                    >
                      <div className="spinner-border text-secondary" role="status" />
                    </div>
                  );
                }
                return (
                  <MediaCard
                    key={idx}
                    data={{ ...data, thumbnail: src }}
                    index={idx}
                    handleOpen={handleOpen}
                    setItem={setItem}
                  />
                );
              })}

              <Lightbox
                styles={{
                  container: {
                    margin: 'auto',
                    backgroundColor: 'rgba(0, 0, 0, .8)',
                    zIndex: '100',
                  },
                }}
                open={open}
                index={Number(item)}
                close={() => setOpen(false)}
                // @ts-ignore
                slides={[
                  ...media?.map((imageData: any) => {
                    if (imageData?.type.includes('image')) {
                      const url = getMediaUrl(imageData?.url);
                      const isHeic = url?.toLowerCase().endsWith('.heic');
                      const id = imageData?.id || url;
                      // Get the src: use the converted image if available, otherwise use the original URL
                      const src = isHeic && convertedImages[id] ? convertedImages[id] : url;
                      return {
                        src: src,
                        title: (
                          <UserProfileHeader
                            data={imageData}
                            src={
                              imageData?.uploadedBy === 'P'
                                ? imageData?.provider?.profile_image
                                : imageData?.client?.profile_image
                            }
                            name={
                              imageData?.uploadedBy === 'P'
                                ? imageData?.provider?.first_name +
                                ' ' +
                                imageData?.provider?.last_name
                                : imageData?.client?.first_name + ' ' + imageData?.client?.last_name
                            }
                          />
                        ),
                        description: <UserProfileFooter item={imageData} />,
                      }
                    } else {
                      return {
                        type: 'video',
                        width: 1050,
                        height: 550,
                        poster: getMediaUrl(imageData?.thumbnail),
                        title: (
                          <UserProfileHeader
                            data={imageData}
                            src={
                              imageData?.uploadedBy === 'P'
                                ? imageData?.provider?.profile_image
                                : imageData?.client?.profile_image
                            }
                            name={
                              imageData?.uploadedBy === 'P'
                                ? imageData?.provider?.first_name +
                                ' ' +
                                imageData?.provider?.last_name
                                : imageData?.client?.first_name + ' ' + imageData?.client?.last_name
                            }
                          />
                        ),
                        description: <UserProfileFooter item={imageData} />,
                        sources: [
                          {
                            src: getMediaUrl(imageData?.url),
                            type: `${imageData?.type}/mp4`,
                          },
                        ],
                      }
                    }
                  }),
                ]}
                render={
                  {
                    // buttonPrev: () => null,
                    // buttonNext: () => null,
                  }
                }
                video={{
                  autoPlay: true,
                  controls: true,
                }}
                plugins={[Captions, Video]}
              />
            </div>
          </InfiniteScroll>
        )} */}

        <div
          style={{
            overflow: 'auto',
            whiteSpace: 'nowrap',
          }}
          className='card mb-5 mb-xl-10 p-5'
        >
          {mediaStatus === 'loading' ? (
            <TableLoading />
          ) : (
            <MUITable
              data={tableData}
              page={currentPage}
              perPage={rowsPerPage}
              setPage={setCurrentPage}
              setPerPage={setRowsPerPage}
            />
          )}
        </div>

        <Lightbox
          open={open}
          index={slideIndex}
          close={closeMediaDetail}
          slides={detailSlides}
          carousel={{finite: true}}
          on={{
            view: ({index}) => setSlideIndex(index),
          }}
          render={{
            buttonPrev: detailSlides.length <= 1 ? () => null : undefined,
            buttonNext: detailSlides.length <= 1 ? () => null : undefined,
            controls: () =>
              detailSlides.length > 1 ? (
                <div
                  style={{
                    position: 'absolute',
                    bottom: 110,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    display: 'flex',
                    gap: 8,
                    zIndex: 2,
                    padding: '6px 10px',
                    borderRadius: 20,
                    background: 'rgba(0, 0, 0, 0.35)',
                  }}
                >
                  {detailSlides.map((_, i) => (
                    <button
                      key={i}
                      type='button'
                      aria-label={`Go to image ${i + 1}`}
                      onClick={() => setSlideIndex(i)}
                      style={{
                        width: i === slideIndex ? 10 : 8,
                        height: i === slideIndex ? 10 : 8,
                        borderRadius: '50%',
                        border: 'none',
                        padding: 0,
                        cursor: 'pointer',
                        background:
                          i === slideIndex ? '#ffffff' : 'rgba(255, 255, 255, 0.45)',
                        transition: 'all 0.2s ease',
                      }}
                    />
                  ))}
                </div>
              ) : null,
          }}
          video={{autoPlay: true, controls: true}}
          plugins={[Captions, Video]}
          styles={{
            container: {
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
            },
          }}
        />
      </div>
    </>
  )
}

export { Explore }
